import { Component, Input, OnChanges } from '@angular/core';
import { ISerialDevice, ISerialMatchResult, matchSerials, SERIAL_CSV_HEADER, toCsv } from './serial-matching';

/** Counts under the device search when serial numbers are searched in bulk. */
@Component({
  selector: 'app-serial-search-stats',
  templateUrl: './serial-search-stats.component.html',
  styleUrls: ['./serial-search-stats.component.scss'],
  standalone: false
})
export class SerialSearchStatsComponent implements OnChanges {
  @Input() serials: string[] = [];
  /** Devices that can be added. */
  @Input() devices: ISerialDevice[] = [];
  /** Devices already assigned, counted apart from "not found". */
  @Input() assigned: ISerialDevice[] = [];

  result: ISerialMatchResult<ISerialDevice> | null = null;

  ngOnChanges(): void {
    this.result = this.serials.length ? matchSerials(this.serials, this.devices, this.assigned) : null;
  }

  downloadNotFound(): void {
    if (!this.result?.notFound.length) return;
    const url = URL.createObjectURL(new Blob([toCsv(SERIAL_CSV_HEADER, this.result.notFound)], { type: 'text/csv;charset=utf-8' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'serials-not-found.csv';
    link.click();
    setTimeout(() => URL.revokeObjectURL(url));
  }
}
